import { get } from '../utils/api';

export const isTwoWayApiConfigured = (): boolean =>
  Boolean(import.meta.env.REACT_APP_TWO_WAY_API_URL);

export class TwoWayCommunicationService {
  async getConversationsByRecipientsIds(
    recipientsIds: string[],
    options?: { signal?: AbortSignal },
  ) {
    const recipientsSearchParams = recipientsIds
      .map((recipientId) => `recipientId=${recipientId}`)
      .join('&');

    return get(
      `${
        import.meta.env.REACT_APP_TWO_WAY_API_URL
      }/conversations?${recipientsSearchParams}`,
      { ...options, isOtherApi: true },
    );
  }
  async getHasNotifications({ propertyId }) {
    if (!propertyId) return {};

    const urlSearchParams = new URLSearchParams({ propertyId });

    return get(
      `/two-way-communication/has-notifications?${urlSearchParams.toString()}`,
    );
  }
  async getPortfolioTwoWayStatus(organizationId: string): Promise<{
    hasActiveTwoWayCommunicationProperties: boolean,
    properties: Array<{ id: string, isTwoWayCommunicationActive: boolean }>,
  }> {
    return get(`/two-way-communication/${organizationId}/portfolio-status`);
  }
  async getHubNotifications({ propertyId }: { propertyId?: string }): Promise<{
    hasNewMessages: boolean,
    hasUnresolvedConversations: boolean,
    hasConversationsNeedingHelp: boolean,
  }> {
    const params = new URLSearchParams();
    if (propertyId) {
      params.append('propertyId', propertyId);
    }
    const queryString = params.toString();
    const baseUrl = `${
      import.meta.env.REACT_APP_TWO_WAY_API_URL || ''
    }/hub/notifications`;
    const url = `${baseUrl}${queryString ? `?${queryString}` : ''}`;
    return get(url, { isOtherApi: true });
  }
}
